






import Bar from '@/views/templates/header/Bar.vue'

export default
  name: 'Header'

  components: {
    Bar
  }
